// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.form-control[data-v-a5a78f78]{height:34px}.avatar-select[data-v-a5a78f78]{position:absolute;top:1px;left:1px;border-radius:10px 0 0 10px!important;z-index:1}.indent[data-v-a5a78f78]{padding-left:50px!important}.flex-start-image[data-v-a5a78f78]{top:1px;position:relative}", ""]);
// Exports
module.exports = exports;
